import React, { useRef, useState } from 'react';

const ImageUpload = ({ onFileSelect, selectedFile, onProcess, isLoading }) => {
  const fileInputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      onFileSelect(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      onFileSelect(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedFile && onProcess) {
      onProcess();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div
        className={`cursor-pointer bg-primary-50 rounded-lg p-8 text-center border-2 border-dashed transition-all ${
          dragActive 
            ? 'border-primary-500 bg-primary-100 shadow-primary' 
            : 'border-primary-200 hover:border-primary-400 hover:shadow-primary'
        }`}
        onClick={() => fileInputRef.current?.click()}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <i className="ph-cloud-arrow-up text-5xl text-primary-400 mb-3 inline-block"></i>
        <p className="font-semibold text-primary-600">Nhấn để tải ảnh của bạn</p>
        <p className="text-sm text-gray-500 mt-1">hoặc kéo và thả ảnh vào đây</p>
        {selectedFile && (
          <p className="text-sm text-primary-700 font-medium mt-2">
            Đã chọn: {selectedFile.name}
          </p>
        )}
      </div>
      
      <input
        ref={fileInputRef}
        type="file"
        className="hidden"
        accept="image/*"
        onChange={handleFileChange}
      />
      
      <button
        type="submit"
        disabled={!selectedFile || isLoading}
        className={`w-full py-3 px-6 text-lg font-semibold rounded-lg shadow-md transition-all flex items-center justify-center gap-2 ${
          !selectedFile || isLoading
            ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
            : 'bg-primary-600 text-white hover:bg-primary-700 hover:shadow-primary-lg'
        }`}
      >
        {isLoading ? (
          <>
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            <span>Đang gửi yêu cầu...</span>
          </>
        ) : (
          <>
            <i className="ph-sparkle text-xl"></i>
            <span>Gửi đến backend</span>
          </>
        )}
      </button>
    </form>
  );
};

export default ImageUpload;